export var PageLayoutType;

(function (PageLayoutType) {
  PageLayoutType["DEFAULT"] = "default";
  PageLayoutType["HEADER_FOOTER"] = "headerFooter";
})(PageLayoutType || (PageLayoutType = {}));

export var PageLayout;

(function (PageLayout) {
  PageLayout["DEFAULT"] = "default";
  PageLayout["HEADER_FOOTER"] = "headerFooter";
  PageLayout["NB_LAYOUT"] = "nbLayout";
})(PageLayout || (PageLayout = {}));

export default {};